// this is the array of version which currently LATEST_SCHEMA_VERSION is compatible with
const compatibleVersions = ['2023-09-28'];

export { compatibleVersions };
//# sourceMappingURL=constants.js.map
